import calendarInlineComponent from './calendarInline.component';

let calendarInlineModule = angular.module('vacations-absences.calendarInline', [])

.component('calendarInline', calendarInlineComponent)

.name;

export default calendarInlineModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInline/calendarInline.js